module.exports = __webpack_public_path__ + "img/2021_09_dande_tokyotower_a4_fin_web.03bf5df4.jpg";